import { render, staticRenderFns } from "./PFGFrunwizard.vue?vue&type=template&id=251297dc"
import script from "./PFGFrunwizard.vue?vue&type=script&lang=js"
export * from "./PFGFrunwizard.vue?vue&type=script&lang=js"
import style0 from "./PFGFrunwizard.vue?vue&type=style&index=0&id=251297dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports